import { font } from '@styles/fonts';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import type { Events } from '@interfaces/timeline';

export const TIMELINE_CONFIG = {
	gapBetweenBlocks: 20,
}

export const TIMELINE_BLOCK_TITLE_CONFIG = {
	marginBottom: 3,
	fontType: 'Headline' as keyof typeof font,
	textColor: 'Label/Light/Primary',
}

export const PRODUCTIVITY_STATUS_CONFIG = {
	ncFileImageContainerWidth: 60,
	ncFileImageContainerHeight: 40,
}

export const TIMELINE_HAIRLINE_COLOR = 'Hairline/Light/No trans';

export const COUNTS_CONFIG = {
	container: {
		marginBottom: 41,
	},
	colorHighlight: 'System/Light/Blue',
	colorNotHighlight: 'Gray/Light/3' 
}

export const TIMELINE_LINE_CONFIG = {
	height: 20,
	backgroundColor: 'Background/Light/Chart',
	borderRadius: 3,
}

export const TIMELINE_FONT_TYPE = 'Caption 2';
export const TIMELINE_UNDERLINE_TEXT_CONFIG = {
	height: 20,
	color: 'Label/Light/Secondary',
}

export const JOBS_CONFIG = {
	underlineTextAmount: 3,
}

export const TIMELINE_OPERATION_SELECT = ['ProductionOperationNumber', 'ProductionOperationId', 'ProductionStartedOn', 'ProductionEndedOn']

export const TIMELINE_BATCH_SELECT = ['ProductionBatchId', 'StartedOn', 'EndedOn', 'Links', 'NcFileStatus', 'NcFileName', 'NcFileId', 'BatchNumber', 'QuantityEvents'];

export const OMITTED_EVENT_MENU_ITEMS = [NcFileBatchEventType.ACTIVE, NcFileBatchEventType.CHANGE];

export const TIMELINE_EVENTS_ORDER_BY = 'StartedOn asc';

export const EVENT_GROUPING_BREAKPOINT = 0.1;
export const MIN_DISPLAY_BREAKPOINT = 1;

export const EMPTY_EVENTS: Events = Object.freeze({
	loaded: false,
	events: [],
	groupedByNCFile: [],
	groupedByBatch: [],
});

export const SIGNALR_EVENT_NAME = 'OnAddedRealtimeDataToTimeline';
export const SIGNALR_CONNECTION_NAME = 'appHub';
export const SIGNALR_DEFAULT_TIMEOUT = 60;